class ShopTheLookDrawerTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector("button");

    if (!this.button) return;

    this.button.addEventListener("mouseenter", () => {
      this._getData();
    });

    this.button.addEventListener("click", () => {
      this._openModal(this.button);
    });
  }

  disconnectedCallback() {}

  _openModal(sourceElement) {
    const detail = {
      target: "style-shop-the-look-drawer",
      html: this._getData(),
    };
    (sourceElement || this).dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail,
      }),
    );
  }

  _getData() {
    const template = this.querySelector("template");
    const htmlString = template.innerHTML;

    return htmlString;
  }

  _parseData(data) {
    const section = new DOMParser().parseFromString(data, "text/html");
    const targetEl = document
      .createRange()
      .createContextualFragment(section.querySelector("body").innerHTML);

    return targetEl;
  }

  get url() {
    return this.getAttribute("url");
  }

  get sectionId() {
    return this.getAttribute("section-id") || "size-guide";
  }
}

if (!customElements.get("shop-the-look-drawer-trigger")) {
  customElements.define(
    "shop-the-look-drawer-trigger",
    ShopTheLookDrawerTrigger,
  );
}
